import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { StockInventorySummaryDto } from './type/StockInventorySummaryDto';

const ENDPOINT = `${APIConfiguration.sparePart}stockInventory/${COMMON_QUERY_PARAMS.STOCK_ITEM_ID}`;

export interface GetStockInventoryArgs {
  stockInventoryId: string;
}

export default async function getStockInventory(
  payload: GetStockInventoryArgs,
): Promise<BackResponse<StockInventorySummaryDto> | BackResponseFailure> {
  try {
    const base = ENDPOINT.replace(
      COMMON_QUERY_PARAMS.STOCK_ITEM_ID,
      payload.stockInventoryId,
    );
    const url = buildUrl(base, { withStockItemGroupStats: true });

    return await apiCall<BackResponse<StockInventorySummaryDto>>(url, {
      method: SUPPORTED_METHODS.GET,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
